export const validationRules = {
  email: {
    required: 'Пожалуйста, введите электронную почту',
    pattern: {
      value:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: 'Некорректный формат адреса электронной почты',
    },
  },
  password: {
    required: 'Пожалуйста, введите пароль',
    minLength: {
      value: 6,
      message: 'Пароль должен содержать не менее 6 символов',
    },
  },
}
